module.exports = __webpack_public_path__ + "img/pdf-1.5811f98a.jpg";